import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { EstensioneService } from 'src/app/services/estensione.service';
import { ToastrService } from 'ngx-toastr';
import { extensions } from '../config';
import { Estensione } from 'src/app/models/estensione';
import { CompagniaService } from 'src/app/services/compagnia.service';
import { StatoIncaricoService } from 'src/app/services/stato-incarico.service';

@Component({
  selector: 'app-integrazione-groupama',
  templateUrl: './integrazione-groupama.component.html',
  styleUrls: ['./integrazione-groupama.component.scss']
})
export class IntegrazioneGroupamaComponent implements OnInit {

  slug: string = extensions.groupama;
  form: FormGroup;
  loggedInUser: User;
  extension: Estensione | null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private estensioneService: EstensioneService,
    private toast: ToastrService,
    private compagniaService: CompagniaService,
    private statoIncaricoService: StatoIncaricoService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.loggedInUser = this.authService.loggedInUser.getValue();

    this.form = this.fb.group({
      username: '',
      password: '',
      compagnia: '',
      statoDefault: '',
      enabled: false,
      accettaIncarico: false,
    });

    try {
      this.extension = await this.estensioneService.bySlug(this.slug);

      if (this.extension && this.extension.id) {
        this.form.patchValue({
          username: this.extension.configuration?.username ?? '',
          password: this.extension.configuration?.password ?? '',
          enabled: this.extension.enabled,
          accettaIncarico: this.extension.configuration?.accetta_incarico ?? false,
        });

        await this.patchCompagniaControl(this.extension.configuration?.compagnia_id);
        await this.patchStatoDefault(this.extension.configuration?.default_stato_id);
      }
    } catch (err) {
      console.error(err);
    }
  }

  private async patchStatoDefault(statoId?: number | string | null) {
    if (!statoId) return;
    try {
      const stato = await this.statoIncaricoService.getOne(statoId as number);
      this.form.patchValue({
        statoDefault: {
          id: stato.id,
          humanIdentifier: stato.humanIdentifier ?? stato.nome ?? stato.id
        }
      });
    } catch (err) {
      console.error(err);
      this.form.patchValue({ statoDefault: statoId });
    }
  }

  private async patchCompagniaControl(compagniaId?: number | string | null) {
    if (!compagniaId) return;
    try {
      const comp = await this.compagniaService.getOne(compagniaId as number);
      this.form.patchValue({
        compagnia: comp ? { id: comp.id, humanIdentifier: comp.nome, nome: comp.nome } : compagniaId,
      });
    } catch (err) {
      console.error(err);
      this.form.patchValue({ compagnia: compagniaId });
    }
  }

  async Salva() {
    const conf = JSON.stringify({
      username: this.form?.value.username,
      password: this.form?.value.password,
      compagnia_id: this.form?.value.compagnia?.id ?? this.form?.value.compagnia ?? null,
      default_stato_id: this.form?.value.statoDefault?.id ?? this.form?.value.statoDefault ?? null,
      accetta_incarico: !!this.form?.value.accettaIncarico,
    });

    const params = {
      slug: this.slug,
      configuration: conf,
      enabled: !!this.form?.value.enabled,
      studio_id: this.loggedInUser.studio_id,
    };

    try {
      const res = await this.estensioneService.saveOrUpdate(params, this.slug);

      if (res.created && res.updated) {
        return this.toast.error('Errore nel server');
      }

      if (res.created) {
        return this.toast.success('Configurazione creata');
      }

      if (res.updated) {
        return this.toast.success('Configurazione salvata');
      }
    } catch (err) {
      console.error(err);
      return this.toast.error('Impossibile salvare la configurazione');
    }
  }
}
